<div *ngIf="clientName === 'CO'">
    <div *ngIf="isCreditCardValidation || isScheduledPaymentValidation;">
      <!-- <epay-lib-co-validation [baseurl]="baseurl" [isEditPayment]="isEditPayment" [validationType]="validationType"
        [editPayorCollection]=" editPayorCollection" (validPayorEmitter_CO)="validPayorEmitted_CO($event)"
        (validPayorCreditCardEmitter_CO)="validPayorCreditCardEmitted_CO($event)">
      </epay-lib-co-validation> -->

      <emp-cc-validation [baseurl]="baseurl" [isEditPayment]="isEditPayment" [validationType]="validationType"
        [editPayorCollection]=" editPayorCollection" (validPayorEmitter_CO)="validPayorEmitted_CO($event)"
        (validPayorCreditCardEmitter_CO)="validPayorCreditCardEmitted_CO($event)">
      </emp-cc-validation>
    </div>
  </div>